import headingTemplate from './heading.ejs';
import styles from './styles.less';

export default (props: any) => headingTemplate({ ...props, styles });
